import React, { useContext, useEffect } from 'react';
import { GlobalContext } from '../../context/GlobalContext';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function JobList() {
    const { state, functions, handlers } = useContext(GlobalContext);
    const { jobData, setJobData, fetchStatus, setFetchStatus, companyList, cityList, search } = state;
    const { formatSalary, formatText } = functions;
    const { handleEdit, handleDelete, handleFilter, handleSearch, handleReset } = handlers;

    useEffect(() => {
        if (fetchStatus === true) {
            axios.get('https://dev-example.sanbercloud.com/api/job-vacancy')
                .then((response) => {
                    setJobData(response.data.data);
                })
                .catch((error) => {
                    console.log(error);
                })

            setFetchStatus(false);
        }
    }, [setJobData, setFetchStatus, fetchStatus])

    return (
        <>
            <div className='mb-10 ml-10'>
                <form className='flex flex-col gap-y-5'>
                    <div className='w-11/12 md:w-1/3'>
                        <label htmlFor="search" className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-gray-300">Search</label>
                        <div className="relative">
                            <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                                <svg aria-hidden="true" className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
                            </div>
                            <input onChange={handleSearch} value={search} type="search" id="search" className="block p-4 pl-10 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-sky-500 focus:border-sky-500" placeholder="Developer..." />
                            <button onClick={handleReset} type="submit" className="text-white absolute right-2.5 bottom-2.5 bg-sky-500 hover:bg-sky-600 focus:outline-none focus:ring-sky-300 font-medium rounded-lg text-sm px-4 py-2">Reset</button>
                        </div>
                    </div>
                    <div className='flex md:w-7/12 gap-x-5'>
                        <select onChange={handleFilter} id="company" name='company' className="w-2/5 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block p-2.5">
                            <option value={''}>All Companies</option>
                            {companyList !== null && companyList.map((company, id) => {
                                return (
                                    <option key={id} value={company}>{company}</option>
                                )
                            })}
                        </select>
                        <select onChange={handleFilter} id="city" name='city' className="w-1/3 md:w-1/4 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block p-2.5">
                            <option value={''}>All City</option>
                            {cityList !== null && cityList.map((city, id) => {
                                return (
                                    <option key={id} value={city}>{city}</option>
                                )
                            })}
                        </select>
                        <select onChange={handleFilter} id="status" name='status' className="w-1/3 md:w-1/4 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-sky-500 focus:border-sky-500 block p-2.5">
                            <option value={''}>All Status</option>
                            <option value={1}>Open</option>
                            <option value={0}>Closed</option>
                        </select>
                    </div>
                </form>
            </div>

            <div className="overflow-auto w-[58.5rem] shadow-md sm:rounded-lg ml-10">
                <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-white uppercase bg-sky-500 dark:bg-gray-700 dark:text-gray-400">
                        <tr className='py-2'>
                            <th scope="col" className="py-4 px-6">
                                No
                            </th>
                            <th scope="col" className="py-4 px-6">
                                Title
                            </th>
                            <th scope="col" className="py-4 px-6">
                                Status
                            </th>
                            <th scope="col" className="py-4 px-6">
                                Description
                            </th>
                            <th scope="col" className="py-4 px-6">
                                Qualification
                            </th>
                            <th scope="col" className="py-4 px-6">
                                Type
                            </th>
                            <th scope="col" className="py-4 px-6">
                                Tenure
                            </th>
                            <th scope="col" className="py-4 px-6">
                                Company
                            </th>
                            <th scope="col" className="py-4 px-6">
                                Image URL
                            </th>
                            <th scope="col" className="py-4 px-6">
                                City
                            </th>
                            <th scope="col" className="py-4 px-6 whitespace-nowrap">
                                Min Salary
                            </th>
                            <th scope="col" className="py-4 px-6 whitespace-nowrap">
                                Max Salary
                            </th>
                            <th scope="col" className="py-4 px-6">
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {jobData !== null && jobData.map((result, index) => {
                            const { id, company_image_url, company_city, company_name, title, job_type, job_status, job_tenure, job_description, job_qualification, salary_min, salary_max } = result;

                            return (
                                <tr key={id} className="bg-white border-b dark:bg-gray-900 dark:border-gray-700">
                                    <th scope="row" className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {index + 1}
                                    </th>
                                    <td className="py-4 px-6 whitespace-nowrap">
                                        {title}
                                    </td>
                                    <td className="py-4 px-6">
                                        <div className={`py-1 px-3 rounded-full ${job_status === 0 ? 'bg-rose-600' : 'bg-green-400'}`}>
                                            <p className='text-center text-white'>{job_status === 0 ? 'Closed' : 'Open'}</p>
                                        </div>
                                    </td>
                                    <td className="py-4 px-6">
                                        {formatText(job_description)}
                                    </td>
                                    <td className="py-4 px-6">
                                        {formatText(job_qualification)}
                                    </td>
                                    <td className="py-4 px-6 whitespace-nowrap">
                                        {job_type}
                                    </td>
                                    <td className="py-4 px-6 whitespace-nowrap">
                                        {job_tenure}
                                    </td>
                                    <td className="py-4 px-6">
                                        {company_name}
                                    </td>
                                    <td className="py-4 px-6 whitespace-nowrap">
                                        {`${company_image_url.substring(0, 20)}...`}
                                    </td>
                                    <td className="py-4 px-6">
                                        {company_city}
                                    </td>
                                    <td className="py-4 px-6 whitespace-nowrap">
                                        {formatSalary(salary_min)}
                                    </td>
                                    <td className="py-4 px-6 whitespace-nowrap">
                                        {formatSalary(salary_max)}
                                    </td>
                                    <td className="py-4 px-6">
                                        <div className='flex'>
                                            <button onClick={handleEdit} value={id} className="text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-3 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700">Edit</button>

                                            <button onClick={handleDelete} value={id} className="focus:outline-none text-white bg-rose-600 hover:bg-rose-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-3 py-2.5 mr-2 mb-2 dark:bg-red-600 dark:hover:bg-red-600 dark:focus:ring-red-900">Delete</button>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}

                    </tbody>
                </table>
            </div>
            <ToastContainer />
        </>
    );
}

export default JobList;